import { render, staticRenderFns } from "./CurrentEventsTab.vue?vue&type=template&id=ad167a1a&scoped=true&"
import script from "./CurrentEventsTab.vue?vue&type=script&lang=js&"
export * from "./CurrentEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad167a1a",
  null
  
)

export default component.exports